<template>
    <div>
        <span class="block w-3/4 h-6 bg-gray-200 rounded mb-1"></span>
        <span class="form-input block w-full h-[42px] bg-gray-200"></span>
    </div>
</template>